import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex items-center gap-2",
  "data-test": "country-flag"
}
const _hoisted_2 = ["src"]

import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryFlag',
  props: {
    label: {},
    flag: {},
    hideCurrency: { type: Boolean }
  },
  setup(__props: any) {

/*  eslint-disable import/no-dynamic-require, global-require */
const props = __props;

const flagUrl = ref(' ');

onMounted(() => {
	try {
		flagUrl.value = require(`./flags/${props.flag?.toLowerCase()}.webp`);
	} catch {
		flagUrl.value = ' ';
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: flagUrl.value,
      alt: "Country flag",
      width: "24",
      height: "16",
      "data-test": "flag-img",
      class: "border-1-neutral rounded-1"
    }, null, 8, _hoisted_2),
    _withDirectives(_createElementVNode("span", {
      class: "text-weight-medium",
      "data-test": "flag-label"
    }, _toDisplayString(_ctx.label?.toUpperCase() || '-'), 513), [
      [_vShow, !_ctx.hideCurrency]
    ])
  ]))
}
}

})